import React from 'react';
import { LiveCasinoGamesListComponent } from './casino_section_components';

export default (props) => (
  <LiveCasinoGamesListComponent
    {...props}
    useLargeImages
    forceWideTile
    orientation="vertical"
    className="right-sidebar-components__casino-games-list"
  />
);
